(function () {
  'use strict';

  if (window.__amourConciergeCartReady) return;
  window.__amourConciergeCartReady = true;

  function initConciergeCart() {
    var drawer = document.querySelector('[data-amour-cart-drawer]');
    if (!drawer) return;

    var root = drawer.dataset.cartRoot || '/';
    if (root.slice(-1) !== '/') root += '/';
    var moneyFormat = drawer.dataset.moneyFormat || window.money_format || '${{amount}}';
    var titleNode = drawer.querySelector('[data-amour-cart-title]');
    var deliveryNode = drawer.querySelector('[data-amour-cart-delivery]');
    var deliveryTextNode = drawer.querySelector('[data-amour-cart-delivery-text]');
    var itemsScrollNode = drawer.querySelector('[data-amour-cart-items-scroll]');
    var loadingNode = drawer.querySelector('[data-amour-cart-loading]');
    var itemsNode = drawer.querySelector('[data-amour-cart-items]');
    var emptyNode = drawer.querySelector('[data-amour-cart-empty]');
    var conciergeNode = drawer.querySelector('[data-amour-cart-concierge]');
    var footerNode = drawer.querySelector('[data-amour-cart-footer]');
    var subtotalNode = drawer.querySelector('[data-amour-cart-subtotal]');
    var savingsRow = drawer.querySelector('[data-amour-cart-savings-row]');
    var savingsNode = drawer.querySelector('[data-amour-cart-savings]');
    var totalNode = drawer.querySelector('[data-amour-cart-total]');
    var installmentNode = drawer.querySelector('[data-amour-cart-installment]');
    var liveNode = drawer.querySelector('[data-amour-cart-live]');
    var errorNode = drawer.querySelector('[data-amour-cart-error]');
    var errorTextNode = drawer.querySelector('[data-amour-cart-error-text]');
    var retryButton = drawer.querySelector('[data-amour-cart-retry]');
    var initialNode = drawer.querySelector('[data-amour-cart-initial]');
    var lastFocused = null;
    var lastAction = null;
    var cart = null;

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoney(cents) {
      var value = Number(cents || 0) / 100;
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);

      function withDelimiters(number, precision, thousands, decimal) {
        var fixed = Number(number || 0).toFixed(precision);
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return precision ? parts[0] + decimal + parts[1] : parts[0];
      }

      if (!match) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
          }).format(value);
        } catch (error) {
          return value.toFixed(2);
        }
      }

      var token = match[1];
      var formatted;
      if (token === 'amount_no_decimals') formatted = withDelimiters(value, 0, ',', '.');
      else if (token === 'amount_with_comma_separator') formatted = withDelimiters(value, 2, '.', ',');
      else if (token === 'amount_no_decimals_with_comma_separator') formatted = withDelimiters(value, 0, '.', ',');
      else if (token === 'amount_with_space_separator') formatted = withDelimiters(value, 2, ' ', ',');
      else if (token === 'amount_no_decimals_with_space_separator') formatted = withDelimiters(value, 0, ' ', ',');
      else if (token === 'amount_with_apostrophe_separator') formatted = withDelimiters(value, 2, "'", '.');
      else formatted = withDelimiters(value, 2, ',', '.');

      return moneyFormat.replace(match[0], formatted);
    }

    function imageUrl(item) {
      var source = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (!source) return '';
      if (/([?&])width=\d+/.test(source)) return source.replace(/([?&])width=\d+/, '$1width=420');
      return source + (source.indexOf('?') === -1 ? '?width=420' : '&width=420');
    }

    function deliveryDates(items) {
      var dates = (items || []).map(function (item) {
        return String(item.properties && item.properties['Estimated delivery between'] || '').trim();
      });
      // Mixed/missing ranges remain on individual lines, never a combined promise.
      if (!dates.length || dates.some(function (date) { return !date || date !== dates[0]; })) return '';
      return dates[0];
    }

    function setBusy(isBusy) {
      drawer.classList.toggle('is-busy', isBusy);
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-amour-cart-remove]'), function (control) {
        control.disabled = isBusy;
      });
      drawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    function showError(message) {
      if (loadingNode) loadingNode.hidden = true;
      if (errorTextNode) errorTextNode.textContent = message || drawer.dataset.updateError;
      if (errorNode) errorNode.hidden = false;
      if (liveNode) liveNode.textContent = message || drawer.dataset.updateError;
    }

    function clearError() {
      if (errorNode) errorNode.hidden = true;
    }

    function renderLine(item) {
      var options = Array.isArray(item.options_with_values) ? item.options_with_values.map(function (option) { return option.value; }).filter(Boolean) : [];
      var stockState = String(item.properties && item.properties['_Amour stock state'] || '').trim();
      var stockDelivery = String(item.properties && item.properties['_Amour delivery display'] || '').trim();
      var properties = item.properties && typeof item.properties === 'object' ? Object.keys(item.properties).filter(function (key) {
        return key.charAt(0) !== '_' && (!stockState || key !== 'Estimated delivery between') && String(item.properties[key] == null ? '' : item.properties[key]).trim() !== '';
      }) : [];
      var originalLinePrice = item.original_line_price == null ? item.final_line_price : item.original_line_price;
      var finalLinePrice = item.final_line_price == null ? item.line_price : item.final_line_price;
      var saving = Math.max(originalLinePrice - finalLinePrice, 0);
      var locale = (document.documentElement.lang || 'en').split('-')[0];
      var de = locale === 'de';
      var sv = locale === 'sv';
      var confirmLater = item.properties && item.properties['Custom ring size'] === 'I will confirm the size later';
      if (de) options = options.map(function (value) { return value.replace('Platinum 950', 'Platin 950').replace('18K White Gold', '18 K Weißgold').replace('SIZE-ADJUSTABLE (Fits any size)', 'Größenverstellbar').replace(/Custom Size \(made-to-order\)/, confirmLater ? 'Ich bestätige die Größe später' : 'Sondergröße'); });
      if (sv) options = options.map(function (value) { return value.replace('Platinum 950', 'Platina 950').replace('18K White Gold', '18 K vitguld').replace('SIZE-ADJUSTABLE (Fits any size)', 'Justerbar storlek (passar alla storlekar)').replace(/Custom Size \(made-to-order\)/, confirmLater ? 'Jag bekräftar storleken senare' : 'Specialstorlek (tillverkas på beställning)'); });
      var optionMarkup = options.length ? '<p class="amour-cart-line__options">' + options.map(escapeHtml).join(escapeHtml(drawer.dataset.optionSeparator || ' · ')) + '</p>' : '';
      var propertyMarkup = properties.map(function (key) {
        var label = key === 'Custom ring size' && de ? 'Ringgröße' : key === 'Custom ring size' && sv ? 'Ringstorlek' : key;
        var value = item.properties[key] === 'I will confirm the size later' && de ? 'Ich bestätige die Größe später' : item.properties[key] === 'I will confirm the size later' && sv ? 'Jag bekräftar storleken senare' : item.properties[key];
        return '<p class="amour-cart-line__property"><span>' + escapeHtml(label) + ':</span> ' + escapeHtml(value) + '</p>';
      }).join('');
      if (stockDelivery) {
        propertyMarkup = '<p class="amour-cart-line__property"><span>' + escapeHtml(drawer.dataset.stockDeliveryLabel) + ':</span> ' + escapeHtml(stockDelivery) + '</p>' + propertyMarkup;
      }
      var originalMarkup = originalLinePrice > finalLinePrice ? '<s>' + formatMoney(originalLinePrice) + '</s>' : '';
      var savingMarkup = saving > 0 ? '<span>' + escapeHtml(drawer.dataset.saveLabel) + ' ' + formatMoney(saving) + '</span>' : '';
      var productTitle = item.product_title || item.title || '';
      var productUrl = item.url || '#';
      var lineKey = escapeHtml(item.key);
      return '<li class="amour-cart-line" data-amour-cart-line data-line-key="' + lineKey + '">' +
        '<div class="amour-cart-line__main">' +
          '<a class="amour-cart-line__image notranslate" translate="no" href="' + escapeHtml(productUrl) + '"><img src="' + escapeHtml(imageUrl(item)) + '" width="210" height="210" alt="' + escapeHtml(productTitle) + '" loading="eager"></a>' +
          '<div class="amour-cart-line__details">' +
            '<a class="amour-cart-line__title notranslate" translate="no" href="' + escapeHtml(productUrl) + '">' + escapeHtml(productTitle) + '</a>' +
            optionMarkup +
            propertyMarkup +
            '<div class="amour-cart-line__prices"><strong>' + formatMoney(finalLinePrice) + '</strong>' + originalMarkup + savingMarkup + '</div>' +
            '<button class="amour-cart-line__remove" type="button" data-amour-cart-remove>' + escapeHtml(drawer.dataset.removeLabel) + '</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }

    function paint(nextCart) {
      cart = nextCart;
      if (loadingNode) loadingNode.hidden = true;
      var count = Number(cart.item_count || 0);
      var lineCount = Array.isArray(cart.items) ? cart.items.length : 0;
      var isEmpty = count === 0;
      var title = count === 1 ? drawer.dataset.titleOne : (drawer.dataset.titleOther || '').replace('{{ count }}', count).replace('__COUNT__', count);
      var totalSaving = Math.max((cart.original_total_price || 0) - (cart.total_price || 0), 0);

      if (titleNode) titleNode.textContent = title;
      drawer.classList.toggle('has-multiple-lines', lineCount > 1);
      if (itemsScrollNode && lineCount <= 1) itemsScrollNode.scrollTop = 0;
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (node) { node.textContent = count; });
      var dates = deliveryDates(cart.items);
      if (deliveryNode) { deliveryNode.hidden = isEmpty || !dates; deliveryNode.style.display = isEmpty || !dates ? 'none' : ''; }
      if (deliveryTextNode) deliveryTextNode.innerHTML = dates ? escapeHtml(drawer.dataset.deliveryTemplate || '').replace('__DATES__', '<span class="notranslate" translate="no">' + escapeHtml(dates) + '</span>') : '';
      if (itemsNode) {
        itemsNode.hidden = isEmpty;
        itemsNode.innerHTML = isEmpty ? '' : cart.items.map(renderLine).join('');
      }
      if (emptyNode) emptyNode.hidden = !isEmpty;
      if (conciergeNode) conciergeNode.hidden = isEmpty;
      if (footerNode) footerNode.hidden = isEmpty;
      if (subtotalNode) subtotalNode.textContent = formatMoney(cart.original_total_price || cart.items_subtotal_price || 0);
      if (savingsRow) savingsRow.hidden = totalSaving <= 0;
      if (savingsNode) savingsNode.textContent = '−' + formatMoney(totalSaving);
      if (totalNode) totalNode.textContent = formatMoney(cart.total_price || 0);
      if (installmentNode) installmentNode.textContent = formatMoney(Math.round((cart.total_price || 0) / 3));
      clearError();
    }

    var stockRenderSequence = 0;
    function render(nextCart) {
      var live = window.AmourStockLive;
      if (!live || !live.enabled || !Array.isArray(nextCart.items)) {
        paint(nextCart);
        return;
      }
      var sequence = ++stockRenderSequence;
      var tracked = nextCart.items.filter(function (item) {
        return item.properties && item.properties['_Amour stock state'] && item.variant_id;
      });
      if (!tracked.length) {
        paint(nextCart);
        return;
      }
      function apply(item, record) {
        var dates = live.dateRange(record.deliveryMinDays, record.deliveryMaxDays);
        item.properties['_Amour stock state'] = record.stockState;
        item.properties['_Amour delivery display'] = dates.range;
        item.properties['_Amour delivery start'] = dates.startIso;
        item.properties['_Amour delivery end'] = dates.endIso;
        item.properties['Estimated delivery between'] = dates.range;
      }
      tracked.forEach(function (item) { apply(item, live.madeToOrder()); });
      paint(nextCart);
      live.get(tracked.map(function (item) { return item.variant_id; })).then(function (records) {
        if (sequence !== stockRenderSequence) return;
        tracked.forEach(function (item) { apply(item, records[String(item.variant_id)]); });
        paint(nextCart);
      }).catch(function () {
        // The conservative made-to-order range remains visible on failure.
      });
    }

    var refreshRequest = null;
    function fetchCurrentCart() {
      return fetch(drawer.dataset.cartUrl || root + 'cart', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error(drawer.dataset.updateError);
          return response.text();
        })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html');
          var data = page.querySelector('[data-amour-cart-initial]');
          if (!data) throw new Error(drawer.dataset.updateError);
          var currentCart = JSON.parse(data.textContent);
          if (!currentCart || !Array.isArray(currentCart.items)) throw new Error(drawer.dataset.updateError);
          return currentCart;
        });
    }

    function refreshCart() {
      if (document.documentElement.classList.contains('cart-show')) {
        if (loadingNode) loadingNode.hidden = false;
        if (itemsNode) itemsNode.hidden = true;
        if (emptyNode) emptyNode.hidden = true;
        if (conciergeNode) conciergeNode.hidden = true;
        if (deliveryNode) deliveryNode.hidden = true;
        if (footerNode) footerNode.hidden = true;
        drawer.setAttribute('aria-busy', 'true');
      }
      if (refreshRequest) return refreshRequest;
      lastAction = null;
      clearError();
      refreshRequest = fetchCurrentCart()
        .then(function (nextCart) {
          render(nextCart);
          var live = window.AmourStockLive;
          if (live && live.enabled && live.syncCartDates) {
            return live.syncCartDates(nextCart).then(function (result) {
              if (result.changed) return fetchCurrentCart().then(render);
            });
          }
        })
        .catch(function (error) { showError(error.message || drawer.dataset.updateError); })
        .finally(function () {
          drawer.setAttribute('aria-busy', 'false');
          refreshRequest = null;
        });
      return refreshRequest;
    }
    document.addEventListener('amour:cart-added', refreshCart);

    var checkoutPending = false;
    drawer.addEventListener('click', function (event) {
      var link = event.target.closest('.amour-cart-drawer__checkout');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var live = window.AmourStockLive;
      if (!live || !live.enabled || !live.syncCartDates) return;
      event.preventDefault();
      if (checkoutPending) return;
      checkoutPending = true;
      clearError();
      live.syncCartDates().then(function () {
        window.location.assign(link.href);
      }).catch(function () {
        showError(drawer.dataset.updateError);
        checkoutPending = false;
      });
    }, true);

    function changeLine(key, quantity) {
      lastAction = function () { return changeLine(key, quantity); };
      setBusy(true);
      clearError();
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      }).then(function (response) {
        if (!response.ok) throw new Error(drawer.dataset.updateError);
        return response.json();
      }).then(function (nextCart) {
        render(nextCart);
        if (liveNode) liveNode.textContent = drawer.dataset.updateSuccess;
      }).catch(function (error) {
        showError(error && error.message ? error.message : drawer.dataset.updateError);
      }).finally(function () {
        setBusy(false);
      });
    }

    drawer.addEventListener('click', function (event) {
      var line = event.target.closest('[data-amour-cart-line]');
      if (!line || !cart) return;
      var key = line.dataset.lineKey;
      var item = cart.items.filter(function (candidate) { return candidate.key === key; })[0];
      if (!item) return;
      if (event.target.closest('[data-amour-cart-remove]')) changeLine(key, 0);
    });

    if (retryButton) retryButton.addEventListener('click', function () {
      if (lastAction) lastAction();
      else refreshCart();
    });

    function focusableItems() {
      return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')).filter(function (item) {
        return item.offsetParent !== null;
      });
    }

    document.addEventListener('pointerdown', function (event) {
      if (event.target.closest('[data-cart-toggle]')) drawer.classList.add('is-pointer-open');
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.target.closest('[data-cart-toggle]') && (event.key === 'Enter' || event.key === ' ')) {
        drawer.classList.remove('is-pointer-open');
      }
    }, true);

    var wasOpen = false;
    function syncOpenState() {
      var isOpen = document.documentElement.classList.contains('cart-show');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) refreshCart();
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      if (isOpen) {
        lastFocused = document.activeElement;
        if (itemsScrollNode) itemsScrollNode.scrollTop = 0;
        window.requestAnimationFrame(function () {
          var close = drawer.querySelector('.amour-cart-drawer__close');
          if (close) close.focus();
        });
      } else if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
        lastFocused = null;
        drawer.classList.remove('is-pointer-open');
      }
    }

    new MutationObserver(syncOpenState).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (event) {
      if (!document.documentElement.classList.contains('cart-show') || event.key !== 'Tab') return;
      var items = focusableItems();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    try {
      render(JSON.parse(initialNode.textContent));
    } catch (error) {}
    syncOpenState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initConciergeCart);
  else initConciergeCart();
})();
